var map = {
	"./1.png": "ZsYQ",
	"./2.png": "sSEp",
	"./3.png": "w6pW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7dCO";


//////////////////
// WEBPACK FOOTER
// ./src/pages/board/components/DownloadData/images ^\.\/.*\.png$
// module id = 7dCO
// module chunks = 1